import { styled } from '@mui/material';

const BasicLayout = styled('div')({
  height: 'calc(100vh - 64px)',
  display: 'flex',
  flexDirection: 'column',
});

export default BasicLayout;
